/* ChangePaymentDate.ts */
import { DateUtil } from "../utils/DateUtil";
/** ──────────── NEW ──────────── */
export var CPDType;
(function (CPDType) {
    CPDType["REGULAR"] = "regular";
    CPDType["DSI_SYSTEM"] = "dsi";
})(CPDType || (CPDType = {}));
export class ChangePaymentDate {
    /* ────────────────────────── model props ────────────────────────── */
    _termNumber;
    _humanTermNumber;
    _newDate;
    _originalDate;
    _originalEndDate;
    _active = true;
    _type = CPDType.REGULAR; // NEW
    /* ────────────────────────── JS / binding ───────────────────────── */
    jsTermNumber;
    jsHumanTermNumber;
    jsNewDate;
    jsOriginalDate;
    jsOriginalEndDate;
    jsActive;
    jsType; // NEW
    /* ───────────────────────────────────────────────────────────────── */
    constructor(params) {
        this.termNumber = params.termNumber ?? -1;
        this.newDate = params.newDate;
        if (params.originalDate)
            this.originalDate = params.originalDate;
        if (params.originalEndDate)
            this.originalEndDate = params.originalEndDate;
        this.active = params.active ?? true;
        this.type = params.type ?? CPDType.REGULAR; // NEW
    }
    /* ===== enable / disable ===== */
    get active() {
        return this._active;
    }
    set active(v) {
        this._active = v;
        this.jsActive = v;
    }
    /* ===== type ===== */ // NEW
    get type() {
        return this._type;
    }
    set type(v) {
        this._type = v;
        this.jsType = v;
    }
    /* ===== term ===== */
    get termNumber() {
        return this._termNumber;
    }
    set termNumber(v) {
        if (typeof v !== "number")
            throw new Error("termNumber must be a number");
        this._termNumber = v;
        this._humanTermNumber = v + 1;
        this.jsTermNumber = v;
        this.jsHumanTermNumber = v + 1;
    }
    get humanTermNumber() {
        return this._humanTermNumber;
    }
    /* ===== dates ===== */
    set newDate(v) {
        this._newDate = DateUtil.normalizeDate(v);
        this.jsNewDate = DateUtil.normalizeDateToJsDate(this._newDate);
    }
    get newDate() {
        return this._newDate;
    }
    set originalDate(v) {
        if (v === undefined) {
            this._originalDate = this.jsOriginalDate = undefined;
            return;
        }
        this._originalDate = DateUtil.normalizeDate(v);
        this.jsOriginalDate = DateUtil.normalizeDateToJsDate(this._originalDate);
    }
    get originalDate() {
        return this._originalDate;
    }
    set originalEndDate(v) {
        if (v === undefined) {
            this._originalEndDate = this.jsOriginalEndDate = undefined;
            return;
        }
        this._originalEndDate = DateUtil.normalizeDate(v);
        this.jsOriginalEndDate = DateUtil.normalizeDateToJsDate(this._originalEndDate);
    }
    get originalEndDate() {
        return this._originalEndDate;
    }
    /* ===== binding helpers ===== */
    updateJsValues() {
        this.jsTermNumber = this.termNumber;
        this.jsHumanTermNumber = this.humanTermNumber;
        this.jsNewDate = DateUtil.normalizeDateToJsDate(this.newDate);
        this.jsOriginalDate = this.originalDate ? DateUtil.normalizeDateToJsDate(this.originalDate) : undefined;
        this.jsOriginalEndDate = this.originalEndDate ? DateUtil.normalizeDateToJsDate(this.originalEndDate) : undefined;
        this.jsActive = this.active;
        this.jsType = this.type; // NEW
    }
    updateModelValues() {
        this.termNumber = this.jsTermNumber;
        this.newDate = this.jsNewDate;
        if (this.jsOriginalDate)
            this.originalDate = this.jsOriginalDate;
        if (this.jsOriginalEndDate)
            this.originalEndDate = this.jsOriginalEndDate;
        this.active = this.jsActive;
        this.type = this.jsType; // NEW
    }
    /* ===== serialization ===== */
    get json() {
        return {
            termNumber: this.termNumber,
            newDate: this.newDate.toString(),
            originalDate: this.originalDate?.toString(),
            originalEndDate: this.originalEndDate?.toString(),
            active: this.active,
            type: this.type, // NEW
        };
    }
    toJSON() {
        return this.json;
    }
}
